import { Result, Button, Space } from "antd";
import { useNavigate } from "react-router-dom";

const WrongRoutePage = () => {
    const navigate = useNavigate();

    return (
        <Result
            status="403"
            title="Page does not exist"
            subTitle="Sorry, the page you visited does not exist."
            extra={
                <Space>
                    <Button
                        type="primary"
                        onClick={() => navigate(-2)}
                        style={{ fontFamily: "SF Pro Display" }} // Optional: Ensure font consistency
                    >
                        Go Back
                    </Button>
                    <Button
                        type="primary"
                        onClick={() => navigate('/')}
                        style={{ fontFamily: "SF Pro Display" }} // Optional: Ensure font consistency
                    >
                        Home
                    </Button>
                </Space>
            }
        />
    );
};

export default WrongRoutePage;
